import { initialiseCheckout } from 'actions/CheckoutActions'
import type { AppAction } from 'actions/types/ActionTypes'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import { generateLoyaltyEsimUpsellCheckoutItem } from 'lib/checkout/experiences/cart'
import type { LoyaltyEsimUpsellModalResult } from 'loyalty/components/LoyaltyEsimUpsellModal'

export function startPostPurchaseEsimCheckoutSelection(
  selection: LoyaltyEsimUpsellModalResult,
  order: App.Order,
): AppAction {
  return (dispatch) => {
    if (selection.kind === 'removeUpsell') {
      return
    }

    if (selection.kind !== 'purchase') {
      return
    }

    const intl = getCurrentIntl()
    const { esimOfferId, experience, selectedTicket, countryCode, currentPackage } = selection
    if (!esimOfferId || !experience || !countryCode || !currentPackage) {
      showSnackbar(
        intl.formatMessage({
          id: '0pXtduyE00DbZyPnwg7I',
          defaultMessage: 'This add-on is not available yet. Please try again later.',
          description: 'Warning snackbar when eSIM upsell data is unavailable',
        }),
        'warning',
      )
      return
    }

    const item = generateLoyaltyEsimUpsellCheckoutItem(experience, selectedTicket, {
      countryCode,
      currentPackage,
    })

    dispatch(initialiseCheckout([item], {
      regionCode: order.regionCode,
      currencyCode: order.currencyCode,
      order,
      mode: 'esim-upgrade',
    }))
    dispatch(navigateToCheckout())
  }
}
